var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_circle_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.33398 11.5002L11.0006 8.50016L6.33398 5.50016V11.5002ZM8.00065 15.1668C7.07843 15.1668 6.21176 14.9918 5.40065 14.6418C4.58954 14.2918 3.88398 13.8168 3.28398 13.2168C2.68398 12.6168 2.20898 11.9113 1.85898 11.1002C1.50898 10.2891 1.33398 9.42238 1.33398 8.50016C1.33398 7.57794 1.50898 6.71127 1.85898 5.90016C2.20898 5.08905 2.68398 4.3835 3.28398 3.7835C3.88398 3.1835 4.58954 2.7085 5.40065 2.3585C6.21176 2.0085 7.07843 1.8335 8.00065 1.8335C8.92287 1.8335 9.78954 2.0085 10.6006 2.3585C11.4118 2.7085 12.1173 3.1835 12.7173 3.7835C13.3173 4.3835 13.7923 5.08905 14.1423 5.90016C14.4923 6.71127 14.6673 7.57794 14.6673 8.50016C14.6673 9.42238 14.4923 10.2891 14.1423 11.1002C13.7923 11.9113 13.3173 12.6168 12.7173 13.2168C12.1173 13.8168 11.4118 14.2918 10.6006 14.6418C9.78954 14.9918 8.92287 15.1668 8.00065 15.1668ZM8.00065 13.8335C9.48954 13.8335 10.7506 13.3168 11.784 12.2835C12.8173 11.2502 13.334 9.98905 13.334 8.50016C13.334 7.01127 12.8173 5.75016 11.784 4.71683C10.7506 3.6835 9.48954 3.16683 8.00065 3.16683C6.51176 3.16683 5.25065 3.6835 4.21732 4.71683C3.18398 5.75016 2.66732 7.01127 2.66732 8.50016C2.66732 9.98905 3.18398 11.2502 4.21732 12.2835C5.25065 13.3168 6.51176 13.8335 8.00065 13.8335Z",
    fill: "#FCF7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.d9932761d729e8ac425868081fd69add.svg";
export { ForwardRef as ReactComponent };